import { jsx as _jsx } from "react/jsx-runtime";
import Checkbox from 'antd/es/checkbox';
import TextArea from 'antd/es/input/TextArea';
import Radio from 'antd/es/radio';
import Select from 'antd/es/select';
import { useTheme } from 'styled-components';
import useMediaQuery from '../../../../features/helpers/use-media-query';
import FormItem from '../../../common/form-item';
import FormLabel from '../../../common/form-label';
import validateAnyType from '../../../../features/helpers/form/validate-any-type';
import ReviewRatings from '../../ratings';
const ReviewStepCard = ({ extra, label, name, type, error, placeholder, options, }) => {
    const theme = useTheme();
    const isSmallDesktop = useMediaQuery({ maxWidth: theme.breakpoints.md });
    return (_jsx("div", { children: type === 'rating' ? (_jsx(FormItem, { label: label, extra: extra, name: name, layout: isSmallDesktop ? 'vertical' : 'horizontal', rules: [
                () => ({
                    required: true,
                    validator: validateAnyType({
                        message: error !== null && error !== void 0 ? error : '',
                        isRequired: true,
                    }),
                }),
            ], children: _jsx(ReviewRatings, { size: "medium", defaultValue: 0, style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: isSmallDesktop ? 'flex-start' : 'flex-end',
                } }) })) : (_jsx(FormItem, { name: name, label: _jsx(FormLabel, { label: label, extra: extra }), rules: [
                () => ({
                    required: true,
                    validator: validateAnyType({
                        message: error !== null && error !== void 0 ? error : '',
                        isRequired: true,
                    }),
                }),
            ], children: type === 'select' ? (_jsx(Select, { size: "large", style: { width: '100%' }, placeholder: placeholder, options: options })) : type === 'textarea' ? (_jsx(TextArea, { placeholder: placeholder, size: "large", style: { minHeight: 100, width: '100%' } })) : type === 'radio' ? (_jsx(Radio.Group, { size: "large", options: options })) : (type === 'checkbox' && (_jsx(Checkbox.Group, { options: options }))) })) }));
};
export default ReviewStepCard;
